/**
 * LOCAL STORAGE KEYS
 */
export const COOKIES_KEY = 'crayola_cookies'

/**
 * LOCAL STORAGE CRUD
 */
export const localeStorageSet = (key: string, value: any) => {
  localStorage?.setItem(key, value.toString())
}

export const localeStorageGet = (key: string) => {
  return localStorage?.getItem(key)
}

export const localeStorageRemove = (key: string) => {
  localStorage?.removeItem(key)
}
